export default __webpack_public_path__ + "static/media/logo.0d54b8d2.svg";